import React, { useEffect, useState } from 'react'
import { StockSalesTimeGraphView } from '../StockSalesTimeGraph/StockSalesTimeGraphView'
import { StockSalesGraphView } from './StockSalesGraphView'

import axios from 'axios'

export const StockSalesGraph = (props) => {
    const [stockData, setStockData] = useState([])
    const [rawMerchoidSalesData, setRawMerchoidSalesData] = useState([])
    const [rawAAASalesData, setRawAaaSalesData] = useState([])
    const [filteredMerchoidSalesData, setFilteredMerchoidSalesData] = useState([])
    const [filteredAaaSalesData, setFilteredAaaSalesData] = useState([])
    const [filteredStockData, setFilteredStockData] = useState([])
    const [loading, setLoading] = useState(true)
    const [brands, setBrands] = useState([])
    const [categories, setCategories] = useState([])
    const [suppliers, setSuppliers] = useState([])
    const [startDateDaysFromNow, setStartDateDaysFromNow] = useState(365) //change this to 365 after testing
    const [stockByBrand, setStockByBrand] = useState({})
    const [exclusions, setExclusions] = useState([])
    const [isInclusion, setIsInclusion] = useState(false)
    const [isBadStockBool, setIsBadStockBool] = useState(false)



    //fetch stock data and product data and store in state
    // useEffect(() => {
    //     setLoading(true);
    //     const fetchData = async () => {
    //         const startDate = subtractDaysFromTodaysDate(2); //change this to 365 after testing
    //         const endDate = new Date();
    //         const [merchoidSales, stock, zeroCostProducts, aaaOrders] = await Promise.all([
    //             //sales data
    //             axios.post(process.env.REACT_APP_HOST + 'api/merchoidSales/fetch', {
    //                 params: {
    //                     startDate: startDate,
    //                     endDate: endDate,
    //                 },
    //             }),
    //             //stock data
    //             axios.get(process.env.REACT_APP_HOST + 'api/reports/getProducts'),
    //             //zero-cost products data
    //             axios.get(process.env.REACT_APP_HOST + 'api/zeroCosts/fetch'),
    //             ///aaa orders
    //             axios.post(process.env.REACT_APP_HOST + 'api/aaa/orders', {
    //                 params: {
    //                     startDate: startDate,
    //                     endDate: endDate,
    //                 },
    //             })
    //         ]);


    //         //fill products with zero cost with costs from the zero cost db
    //         const updatedStock = stock.data.products.map((product) => {
    //             const zeroCostProduct = zeroCostProducts.data.find(
    //                 (zcp) => zcp.sku === product.id
    //             );

    //             if (zeroCostProduct && product.productCost === 0) {
    //                 product.productCost = zeroCostProduct.productCost;
    //             } else if (product.productCost === 0) {
    //                 // Find the product cost from sales data, if available
    //                 const foundSale = merchoidSales.data.find((sale) => String(sale.sku) === String(product.id));
    //                 if (foundSale) {
    //                     product.productCost = foundSale.costPrice / foundSale.qty;
    //                 }
    //             }

    //             return product;
    //         });


    //         let qty = 0
    //         stock.data.products.forEach((item) => {
    //             item.qtyByDate.forEach((qtyByDateItem) => {
    //                 if (qtyByDateItem) {
    //                     qty += qtyByDateItem[1];
    //                 }
    //             })
    //         })

    //         //add additional info to sales orders eg suppliers, brands etc from product db

    //         const formattedAaaOrders = formatAaaOrders(aaaOrders.data.filter((x => x.company !== "Merchoid Limited"))); //filter out internal sales

    //         const aaaOrdersWithMetaData = updateSaleSkus(formattedAaaOrders, updatedStock, zeroCostProducts.data);; // Pass updatedStock instead of stock.data
    //         const merchoidOrdersWithMetaData = updateSaleSkus(merchoidSales.data, updatedStock, zeroCostProducts)


    //         //store base ones so can refiltered
    //         setRawMerchoidSalesData(merchoidOrdersWithMetaData)
    //         setRawAaaSalesData(aaaOrdersWithMetaData)
    //         console.log(rawAAASalesData)

    //         //initial data is unfiltered
    //         setFilteredStockData(updatedStock);
    //         setFilteredMerchoidSalesData(merchoidOrdersWithMetaData)
    //         setFilteredAaaSalesData(aaaOrdersWithMetaData)

    //         //update local states
    //         aggregateStockValuesByBrand(updatedStock);
    //         setStockData(updatedStock);
    //         setBrands(stock.brands);
    //         setSuppliers(stock.suppliers);
    //         setCategories(stock.categories);
    //         setLoading(false);
    //     };
    //     fetchData();
    // }, []);

    useEffect(() => {
        setLoading(true);
        axios.get(process.env.REACT_APP_HOST + 'api/reports/getGraphData')
            .then((res) => {
                console.log(res.data)
                setRawMerchoidSalesData(res.data.merchoidSales)
                setRawAaaSalesData(res.data.aaaSales)
                //initial data is unfiltered
                setFilteredStockData(res.data.stockData.products);
                setFilteredMerchoidSalesData(res.data.merchoidSales)
                setFilteredAaaSalesData(res.data.aaaSales)

                //update local states
                aggregateStockValuesByBrand(res.data.stockData.products);
                setStockData(res.data.stockData.products);
                setBrands(res.data.brands);
                setSuppliers(res.data.suppliers);
                setCategories(res.data.categories);
                setLoading(false);
            })

    }, [])

    // const formatAaaOrders = (aaaOrdersData) => {
    //     const formattedAaaOrders = [];

    //     aaaOrdersData.forEach((order) => {
    //         order.products.forEach((product) => {
    //             formattedAaaOrders.push({
    //                 // Add any required fields from the sales data format here and set them to null if they don't exist in the aaaOrders
    //                 date: order.createdAt || null,
    //                 productTitle: product.name || null,
    //                 sku: product.kwSku || null,
    //                 costPrice: product.costPrice * product.quantity || null,
    //                 profit: product.profit || null,
    //                 qty: product.quantity || null,
    //                 sellingPriceGbp: product.totalExVat || null,
    //                 // ...
    //                 salesSource: "aaa", // Add a flag to indicate that the sales source is "aaa"
    //             });
    //         });
    //     });
    //     return formattedAaaOrders;

    // };




    // //adds brands, supplier names and product categories to sales data
    // const updateSaleSkus = (salesData, stockData) => {
    //     const products = stockData;
    //     const updatedSalesData = salesData.map((sale) => {

    //         const foundProduct = products.filter(
    //             (product) => String(product.id) === String(sale.sku)
    //         );

    //         if (foundProduct.length !== 0) {
    //             sale.productBrand = foundProduct[0].productBrand;
    //             sale.productCategory = foundProduct[0].productCategory;
    //             sale.supplierName = foundProduct[0].supplierName;
    //         } else {
    //             sale.productBrand = "Not found";
    //             sale.productCategory = "Not found";
    //             sale.supplierName = "Not found";
    //         }

    //         return sale;
    //     });
    //     return updatedSalesData
    // };

    // const subtractDaysFromTodaysDate = (noOfDays) => {
    //     return new Date(new Date().getTime() - noOfDays * 24 * 60 * 60 * 1000)
    // }


    const onChangeStartDate = (e) => {
        setStartDateDaysFromNow(parseInt(e.target.value, 10));
    };

    const onToggleBadStock = () => {
        setIsBadStockBool(!isBadStockBool)
    }


    //when start date changes, filter sales and stock data
    useEffect(() => {
        // Start with the original data
        let newFilteredMerchoidSalesData = rawMerchoidSalesData;
        let newFilteredAAASalesData = rawAAASalesData;
        let newFilteredStockData = stockData;

        // Perform filtering based on exclusions
        exclusions.forEach((exclusion) => {
            const regex = new RegExp(exclusion, 'i');
            if (!isInclusion) {
                newFilteredMerchoidSalesData = newFilteredMerchoidSalesData.filter(
                    (obj) => !regex.test(obj.productTitle)
                );
                newFilteredAAASalesData = newFilteredAAASalesData.filter(
                    (obj) => !regex.test(obj.productTitle)
                );
                newFilteredStockData = newFilteredStockData.filter(
                    (obj) => !regex.test(obj.productName)
                );
            } else {
                newFilteredMerchoidSalesData = rawMerchoidSalesData.filter((obj) =>
                    regex.test(obj.productTitle)
                );
                newFilteredAAASalesData = rawAAASalesData.filter((obj) =>
                    regex.test(obj.productTitle)
                );
                newFilteredStockData = stockData.filter((obj) =>
                    regex.test(obj.productName)
                );
            }

        });
        //filter stock by bad stock
        newFilteredStockData = newFilteredStockData.filter(x => x.badStock === isBadStockBool)


        // Filter sales data by startDateDaysFromNow
        const filterByDate = (salesData) =>
            salesData.filter((x) => {
                const saleDate = new Date(x.date);
                const currentDate = new Date();
                const dateDiff = Math.abs(currentDate - saleDate);
                const daysDiff = Math.ceil(dateDiff / (1000 * 60 * 60 * 24));
                return daysDiff <= startDateDaysFromNow;
            });

        newFilteredMerchoidSalesData = filterByDate(newFilteredMerchoidSalesData);
        newFilteredAAASalesData = filterByDate(newFilteredAAASalesData);

        // Filter Merchoid sales data for bad stock
        if (newFilteredMerchoidSalesData && newFilteredStockData) {
            if (newFilteredMerchoidSalesData.length > 0 && newFilteredStockData.length > 0) {
                console.log('fire');

                newFilteredMerchoidSalesData = newFilteredMerchoidSalesData.filter((sale) => {
                    return newFilteredStockData.some((product) => {
                        return String(sale.sku) === String(product.id);
                    });
                });
            }
        }

        // Filter AAA sales data for bad stock
        if (newFilteredAAASalesData && newFilteredStockData) {
            if (newFilteredAAASalesData.length > 0 && newFilteredStockData.length > 0) {
                newFilteredAAASalesData = newFilteredAAASalesData.filter((sale) => {
                    return newFilteredStockData.some((product) => {
                        return String(sale.sku) === String(product.id);
                    });
                });
            }
        }



        // Update the state variables after filtering
        setFilteredMerchoidSalesData(newFilteredMerchoidSalesData);
        setFilteredAaaSalesData(newFilteredAAASalesData);
        setFilteredStockData(newFilteredStockData);
    }, [startDateDaysFromNow, exclusions, isBadStockBool],);

    const aggregateStockValuesByBrand = (stock) => {
        // Aggregate stock quantity by productBrand
        const stockByBrand = {};
        stock.forEach((item) => {
            const latestQtyByDate = item.qtyByDate[item.qtyByDate.length - 1];
            if (latestQtyByDate && latestQtyByDate[0]) {
                const qty = latestQtyByDate[latestQtyByDate.length - 1];
                if (qty && typeof qty[1] !== 'undefined' && qty[1] !== null) {
                    const brand = item.productBrand;
                    const quantity = qty[1];
                    if (stockByBrand[brand]) {
                        stockByBrand[brand] += quantity * item.productCost;
                    } else {
                        stockByBrand[brand] = quantity * item.productCost;
                    }
                }
            }
        });
        setStockByBrand(stockByBrand)
    }

    return <>{props.stockSalesTimeGraph && <StockSalesTimeGraphView
        onChangeStartDate={onChangeStartDate}
        startDateDaysFromNow={startDateDaysFromNow}
        loading={loading}
        merchoidSales={filteredMerchoidSalesData}
        aaaSales={filteredAaaSalesData}
        brands={brands}
        suppliers={suppliers}
        categories={categories}
        stock={filteredStockData}
        stockByBrand={stockByBrand}
        setExclusions={setExclusions}
        setIsInclusion={setIsInclusion}
        isInclusion={isInclusion}
        onToggleBadStock={onToggleBadStock}
        setIsBadStockBool={setIsBadStockBool}
        isBadStockBool={isBadStockBool}
    />}


        {props.stockSalesGraph && <StockSalesGraphView
            onChangeStartDate={onChangeStartDate}
            startDateDaysFromNow={startDateDaysFromNow}
            loading={loading}
            merchoidSales={filteredMerchoidSalesData}
            aaaSales={filteredAaaSalesData}
            brands={brands}
            suppliers={suppliers}
            categories={categories}
            stock={filteredStockData}
            stockByBrand={stockByBrand}
            setExclusions={setExclusions}
            setIsInclusion={setIsInclusion}
            setIsBadStockBool={setIsBadStockBool}
            isBadStockBool={isBadStockBool}
            isInclusion={isInclusion}
            onToggleBadStock={onToggleBadStock}

        />}</>
}